import script from "./HighlightsFixtureContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./HighlightsFixtureContainer.vue?vue&type=script&setup=true&lang=js"

import "./HighlightsFixtureContainer.vue?vue&type=style&index=0&id=350db7a1&lang=css"

const __exports__ = script;

export default __exports__